<template>
    <div>
        <div
            class="mt-8 rounded-lg p-4 border"
            :class="[
                rescheduleEnabled
                    ? 'border-z-primary-500 bg-z-primary-25'
                    : 'border-iron-200',
            ]"
        >
            <div class="gap-2.5 flex">
                <Switch v-model:checked="rescheduleEnabled" class="mt-1" />
                <div>
                    <p class="text-sm font-medium text-iron-700">
                        {{ $t("event_types.reschedule.title") }}
                    </p>
                    <p class="text-sm text-iron-500">
                        {{ $t("event_types.reschedule.description") }}
                    </p>
                </div>
            </div>

            <div v-if="rescheduleEnabled" v-auto-animate class="mt-4 pl-[54px]">
                <div class="max-w-sm gap-1 grid w-full">
                    <Label for="rescheduleNotice">{{
                        $t("event_types.reschedule.minimum_notice")
                    }}</Label>
                    <InputWithSelect v-model="rescheduleNotice" />
                    <p class="mt-1 text-xs text-iron-500">
                        {{ $t("event_types.reschedule.notice_description") }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { EventType } from "../types/EventType";
import { EventTypeUser } from "../types/EventTypeUser";
import { ref, watch } from "vue";
import { Switch } from "@/components/ui/switch";
import InputWithSelect from "@/components/ui/input-with-select/InputWithSelect.vue";
import { Label } from "@/components/ui/label";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { vAutoAnimate } from "@formkit/auto-animate";
import { debouncedWatch } from "@vueuse/core";

interface Props {
    eventType: EventType;
    eventTypeUser: EventTypeUser;
}

const props = defineProps<Props>();

const rescheduleEnabled = ref(
    props.eventTypeUser.reschedule_policies.reschedule_enabled,
);
const rescheduleNotice = ref(
    props.eventTypeUser.reschedule_policies.reschedule_notice,
);

watch(rescheduleEnabled, () => {
    saveReschedulePolicy();
});

debouncedWatch(
    rescheduleNotice,
    () => {
        saveReschedulePolicy();
    },
    {
        debounce: 500,
    },
);

function saveReschedulePolicy() {
    router.put(
        route("app.event-types.reschedule-policies.update", {
            eventType: props.eventType.id,
        }),
        {
            rescheduleEnabled: rescheduleEnabled.value,
            rescheduleNotice: rescheduleNotice.value,
        },
    );
}
</script>
